import { makeAutoObservable, runInAction } from "mobx";
import agent from "../../api/agent";
import { UserAudit } from "../../models/Audit/UserAudit";
import { PagingParams } from "../../models/pagination";
import { store } from "../store";


export default class UserAuditStore {
    userAuditList : UserAudit[] = [];

    userActivityLoading = false;
    totalCount: number = 0;
    pagingParams = new PagingParams(10, 0, "-createdAt");

    constructor() {
        makeAutoObservable(this);
    }

    setPagingParams = (pagingParams: PagingParams) => {
        this.pagingParams = pagingParams;
    }

    setPagination = (totalCount: number) => {
        this.totalCount = totalCount;
    }

    get axiosParams() {
        const params = new URLSearchParams();
        params.append('take', this.pagingParams.take.toString());
        params.append('skip', this.pagingParams.skip.toString());
        params.append('sort', this.pagingParams.sort);

        return params;
    }

    loadAuditList = async (userId: string) => {
        this.userActivityLoading = true;

        try {
            var axiosParams = this.axiosParams;
            axiosParams.append('userId', userId);

            const result = await agent.ActivityApi.getUserActivity(axiosParams);

            runInAction(() => {
                this.userAuditList = result.data;
                this.setPagination(result.totalCount);
                this.userActivityLoading = false;
            })
        } catch(error) {
            runInAction(() => this.userActivityLoading = false);
            throw error;
        }
    }
}